(() => {
  const selectors = {
    popularProducts: '.popular-products',
    popularProductsSlider: '.popular-products__slider',
    popularProductsNavigation: '.popular-products__navigation',
    popularProductsPagination: '.popular-products__pagination',
    popularProductsPrev: '.popular-products__button-prev',
    popularProductsNext: '.popular-products__button-next'
  }

  const initPopularProductsSlider = (container = document) => {
    const sliderElement = container.querySelector(selectors.popularProductsSlider);
    if (!sliderElement) return;

    if (sliderElement.classList.contains('swiper-initialized')) return;

    const navigationElement = container.querySelector(selectors.popularProductsNavigation);
    const paginationElement = sliderElement.querySelector(selectors.popularProductsPagination);
    const prevElement = container.querySelector(selectors.popularProductsPrev);
    const nextElement = container.querySelector(selectors.popularProductsNext);
    
    const columns = Number(sliderElement.dataset.columns) || 4;
    
    const mobileColumns = sliderElement.classList.contains('products--2-mobile') ? 
      (columns > 1 ? 2 : 1) : 1;
    
    const tabletColumns = Math.min(3, columns);
    const desktopColumns = columns >= 4 ? columns - 1 : columns;

    const swiper = new Swiper(sliderElement, {
      slidesPerView: mobileColumns,
      slidesPerGroup: mobileColumns,
      spaceBetween: 4,
      speed: 800,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: nextElement,
        prevEl: prevElement
      },
      pagination: {
        el: paginationElement,
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          let paginationHTML = '';
          for (let i = 1; i <= total; i++) {
            const isActive = i === current;
            paginationHTML += `
              <span 
                class="swiper-pagination-bullet ${isActive ? 'swiper-pagination-bullet-active' : ''}" 
                tabindex="0" 
                role="button" 
                aria-label="Go to slide ${i}"
              ></span>
            `;
          }
          return paginationHTML;
        }
      },
      breakpoints: {
        576: {
          slidesPerView: tabletColumns,
          slidesPerGroup: tabletColumns,
        },
        750: {
          slidesPerView: tabletColumns,
          slidesPerGroup: tabletColumns,
          
        },
        990: {
          slidesPerView: desktopColumns,
          slidesPerGroup: desktopColumns,
          
        },
        1200: {
          slidesPerView: columns,
          slidesPerGroup: columns,
          
        }
      },
      on: {
        init() {
          sliderElement.classList.add('swiper-initialized');
        }
      }
    });

    return swiper;
  };

  initPopularProductsSlider();

  document.addEventListener('shopify:section:load', (event) => {
    initPopularProductsSlider(event.target);
  });

  const cleanup = () => {
  };

  window.addEventListener('beforeunload', cleanup);
})();